import * as React from "react";
import type { SVGProps } from "react";
const SvgStroller = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#stroller_svg__a)">
      <path d="M9 22a3 3 0 1 1 0-6 3 3 0 0 1 0 6m0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M19 22a3 3 0 1 1 0-5.999A3 3 0 0 1 19 22m0-4a1 1 0 1 0 0 2 1 1 0 0 0 0-2M15.5 15h-2.67a7 7 0 0 1-6.65-4.79L4.78 6H3a1 1 0 0 1 0-2h2.5a1 1 0 0 1 1 .68l1.63 4.9a5 5 0 0 0 4.7 3.42h2.67a4.507 4.507 0 1 0 .5-9v5a1 1 0 0 1-2 0V3a1 1 0 0 1 1-1h.5a6.5 6.5 0 0 1 0 13" />
      <path d="M21 10H7a1 1 0 0 1 0-2h14a1 1 0 1 1 0 2M10 18a1.3 1.3 0 0 1-.32 0 1 1 0 0 1-.63-1.27l1-3a1.002 1.002 0 1 1 1.9.64l-1 3A1 1 0 0 1 10 18M18 18a1 1 0 0 1-.95-.68l-1-3a1.001 1.001 0 1 1 1.9-.64l1 3a1 1 0 0 1-.63 1.32 1.3 1.3 0 0 1-.32 0" />
    </g>
    <defs>
      <clipPath id="stroller_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgStroller;
